import { render } from "./Paused.vue?vue&type=template&id=a03fbf36&scoped=true&lang=pug"
import script from "./Paused.js?vue&type=script&lang=js&external"
export * from "./Paused.js?vue&type=script&lang=js&external"

import "./Paused.vue?vue&type=style&index=0&id=a03fbf36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03fbf36"]])

export default __exports__